import { AbstractEditEntityComponent } from '@abstracts/entities/edit-entity';
import { formatDate } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Injector, Input, NgZone, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EnableFreeChargeDialogContentComponent } from '@components/dialog/enable-free-charge-dialog-content/enable-free-charge-dialog-content.component';
import { PatchDlmMode } from '@dto/httpPatch/patchDlmMode';
import { DlmMode } from '@enums/dlmMode.enum';
import { ChargingStation } from '@models/charging-station';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { FormService } from '@services/form/form.service';
import { plainToClass } from 'class-transformer';
import { RemoteStartStopDialogContentComponent } from '@components/dialog/remote-start-stop-dialog-content/remote-start-stop-dialog-content.component';
// import { ValueConverter } from '@angular/compiler/src/render3/view/template';
import { ChargingPower } from '../../../../models/chargingPower';
import { ConnectorSystems } from '../../../../models/connectorSystems';
import { Manufacturer } from '../../../../models/manufacturer';
import { MessageService } from '@services/message/message.service';
import { ToastService } from '@services/toast/toast.service';
import { Subscription, interval } from 'rxjs';
import Swal from 'sweetalert2';
import { GetConfigurationRequest } from '@dto/ocpp/getConfigurationRequest';
import { ChargingStationDto } from '../../../../dto/chargingStationDto';
import { NgxSpinnerService } from 'ngx-spinner';
import { KwhPipe } from '../../../../pipes/kwh.pipe';
import { compareVersions } from 'compare-versions';
import { profile } from 'console';

@Component({
  selector: 'app-dlm-charging-station',
  templateUrl: './dlm-charging-station.component.html',
  styleUrls: ['./dlm-charging-station.component.scss'],
})
export class DlmChargingStationComponent extends AbstractEditEntityComponent implements OnInit, AfterViewInit {

  public className = 'DlmChargingStationComponent';

  public entity: ChargingStation;
  public freeChargeStatus: boolean;
  public currentMeterValues: any[] = [];
  public currentMeterValuesSlave: any[] = [];
  public user: boolean = false;
  public customer: boolean = false;
  public MeterSupported: boolean = false;
  public operator: boolean = false;
  public statusClass: string = '';
  public isOperatorView: boolean;
  public isRestartNecessary: boolean = false;
  public dlmClearPersistentSlaves: boolean = false;
  public isDouble: boolean = false;

  // private refreshSub: Subscription;

  chargingPowers: ChargingPower[] = [];

  connectorSystems: ConnectorSystems[] = [];

  manufacturers: Manufacturer[] = [];

  dlmModes: [
    {
      id: 0,
      val: "Deaktiviert",
      name: "Deaktiviert"
    },
    {
      id: 1,
      val: "DLMMasterWithInternalSlave",
      name: "DLM-Master (mit internem DLM-Slave)"
    },
    {
      id: 2,
      val: "Standalone",
      name: "DLM-Master (Standalone)"
    },
    {
      id: 3,
      val: "MasterAutoDiscovery",
      name: "DLM-Slave (Master-Auto-Discovery)"
    },
    {
      id: 4,
      val: "MasterFixedIP",
      name: "DLM-Slave (Master-Fixed-IP)"
    }
  ];
  currentPower: number;
  currentPower_slave: number;
  MeterSupportedSlave: boolean;


  @Input() set entityData(data: ChargingStation) {
    this.entity = data;
  }

  constructor(
    private chargingStationsService: ChargingStationsService,
    private dialog: NgbModal,
    private toastService: ToastService,
    private spinner: NgxSpinnerService,
    public injector: Injector) {
    super(chargingStationsService, injector);
  }

  ngOnInit() {
    this.isOperatorView = this.activatedRoute.snapshot.data['isOperatorView'];
    super.ngOnInit();
    this.chargingStationsService.UpdateDlmSettingsFromOcpp(this.primaryKey.toString()).subscribe(result => {
      this.loadEntity();
    }, error => {
      this.toastService.warn('DLM Einstellungen konnten nicht per OCPP abgefragt werden!');
    });
    this.getCurrentMeterValues();
    this.getRoles();
  }

  async SetStatus(statusId) {
    for (const chargingPoint of this.entity.chargingPoints) {
      this.chargingStationsService.SetStatus(this.primaryKey.toString(), chargingPoint.connectorId, statusId).subscribe(result => {
      }, error => {
        console.error("could not set Status for Chargingstation");
      })
    }
  }

  getCurrentMeterValues() {
    this.chargingStationsService.getSecondMeterCurrent(this.primaryKey.toString(), 1).subscribe(rs => {
      this.currentMeterValues = rs.secondMeterCurrent.replace(/([()])/g, '').replace(/\[A\]/g, '').trim().split(' | ');
      this.currentMeterValues[0] = parseFloat(this.currentMeterValues[0]);
      this.currentMeterValues[1] = parseFloat(this.currentMeterValues[1]);
      this.currentMeterValues[2] = parseFloat(this.currentMeterValues[2]);
      this.currentPower = (this.currentMeterValues[0] * 230) + (this.currentMeterValues[1] * 230) + (this.currentMeterValues[2] * 230);
      this.MeterSupported = true;
      if (this.entity.profile.numberOfConnectors === 2) {
        this.chargingStationsService.getSecondMeterCurrent(this.primaryKey.toString(), 2).subscribe(rss => {
          this.currentMeterValuesSlave = rss.secondMeterCurrent.replace(/([()])/g, '').replace(/\[A\]/g, '').trim().split(' | ');
          this.currentMeterValuesSlave[0] = parseFloat(this.currentMeterValuesSlave[0]);
          this.currentMeterValuesSlave[1] = parseFloat(this.currentMeterValuesSlave[1]);
          this.currentMeterValuesSlave[2] = parseFloat(this.currentMeterValuesSlave[2]);
          this.currentPower_slave = (this.currentMeterValuesSlave[0] * 230) + (this.currentMeterValuesSlave[1] * 230) + (this.currentMeterValuesSlave[2] * 230);
          this.MeterSupportedSlave = true;
        })
      }
    }, error => {
      this.currentMeterValues[0] = parseFloat('0');
      this.currentMeterValues[1] = parseFloat('0');
      this.currentMeterValues[2] = parseFloat('0');
      this.currentPower = parseFloat('0');
      this.MeterSupported = false;
      this.MeterSupportedSlave = false;
      this.currentMeterValuesSlave[0] = parseFloat('0');
      this.currentMeterValuesSlave[1] = parseFloat('0');
      this.currentMeterValuesSlave[2] = parseFloat('0');
      this.currentPower_slave = parseFloat('0');

    });
  }

  getRoles() {
    if (this.authenticationService.userHasRole('Customer')) {
      this.customer = true;
    }
    if (this.authenticationService.userHasRole('Operator')) {
      this.operator = true;
    }
    if (this.authenticationService.userHasRole('User')) {
      this.user = true;
    }
  }


  ngAfterViewInit() {
    // window.dispatchEvent(new Event('resize'));
  }


  ngOnDestroy(): void {
    // this.refreshSub.unsubscribe();
  }


  getAdditionalEntities() {
    this.chargingStationsService.getChargingPower().subscribe(result => {
      this.chargingPowers = result;
    }, error => { });

    this.chargingStationsService.getManufacturer().subscribe(result => {
      this.manufacturers = result;
    }, error => { });

    this.chargingStationsService.getConnectorSystems().subscribe(result => {
      this.connectorSystems = result;
    }, error => { });
  }


  initializeEntity(entity) {
    this.entity = plainToClass(ChargingStation, entity);
    if (this.entity?.model.profile.numberOfConnectors === 2) {
      this.isDouble = true;
    } else {
      this.isDouble = false;
    }
  }



  createForm() {
    this.formService.validators = {
      chargingPower: [Validators.required],
      dlmMode: [Validators.required],
      dlmDiscoveryNetworkId: [Validators.required],
      DlmDisableDiscoveryBroadcast: [Validators.required],
      DlmRecalcInterval: [Validators.required],
      DlmMinCurrentRating: [Validators.required],
      DlmDisconnectedLimit: [Validators.required],
      DlmMasterIp: [],
      DlmAllowEVWakeup: [Validators.required],
      DlmPhase1Limit: [Validators.required],
      DlmPhase2Limit: [Validators.required],
      DlmPhase3Limit: [Validators.required],
      DlmOperatorPhase1Limit: [Validators.required],
      DlmOperatorPhase2Limit: [Validators.required],
      DlmOperatorPhase3Limit: [Validators.required],
      DlmInput1CurrOffsetCfg: [Validators.required],
      DlmInput1Polarity: [Validators.required],
      DlmInput1CurrOffsetPhase1: [Validators.required],
      DlmInput1CurrOffsetPhase2: [Validators.required],
      DlmInput1CurrOffsetPhase3: [Validators.required],
      DlmExtMeterEnabled: [Validators.required],
      SecondMeterType: [Validators.required],
      SecondMeterIPAddress: [Validators.required],
      SecondMeterTCPPortNumber: [Validators.required],
      DlmExtMeterMainDistributionLimitPhase1: [Validators.required],
      DlmExtMeterMainDistributionLimitPhase2: [Validators.required],
      DlmExtMeterMainDistributionLimitPhase3: [Validators.required],
      DlmExtLoadHeadroomPhase1: [Validators.required],
      DlmExtLoadHeadroomPhase2: [Validators.required],
      DlmExtLoadHeadroomPhase3: [Validators.required],
      DlmExtMeterLoadFallbackPhase1: [Validators.required],
      DlmExtMeterLoadFallbackPhase2: [Validators.required],
      DlmExtMeterLoadFallbackPhase3: [Validators.required],
      DlmExtMeterLocation: [Validators.required],
      DlmExtLoadAvgLen: [Validators.required],
      DlmCurrImbalancePreventionEnabled: [Validators.required],
      DlmCurrImbalanceLim: [Validators.required],
      DlmSlaveSolarEnabled: [],
      DlmSolarMode_dlm: []
    }

    this.formService.form = new UntypedFormGroup({
      chargingPower: new UntypedFormControl(this.entity.chargingPower?.ampere, this.formService.validators['chargingPower']),
      dlmMode: new UntypedFormControl(this.entity.chargingStationDlm?.dlmMode, this.formService.validators['dlmMode']),
      DlmDisableDiscoveryBroadcast: new UntypedFormControl(this.entity.chargingStationDlm?.dlmDisableDiscoveryBroadcast ? 1 : 0, this.formService.validators['DlmDisableDiscoveryBroadcast']),
      DlmRecalcInterval: new UntypedFormControl(this.entity.chargingStationDlm?.dlmRecalcInterval, this.formService.validators['DlmRecalcInterval']),
      DlmAllowEVWakeup: new UntypedFormControl(this.entity.chargingStationDlm?.dlmAllowEVWakeup ? 1 : 0, this.formService.validators['DlmAllowEVWakeup']),
      DlmPhase1Limit: new UntypedFormControl(this.entity.chargingStationDlm?.dlmPhase1Limit, this.formService.validators['DlmPhase1Limit']),
      DlmPhase2Limit: new UntypedFormControl(this.entity.chargingStationDlm?.dlmPhase2Limit, this.formService.validators['DlmPhase2Limit']),
      DlmPhase3Limit: new UntypedFormControl(this.entity.chargingStationDlm?.dlmPhase3Limit, this.formService.validators['DlmPhase3Limit']),
      DlmOperatorPhase1Limit: new UntypedFormControl(this.entity.chargingStationDlm?.dlmOperatorPhase1Limit, this.formService.validators['DlmOperatorPhase1Limit']),
      DlmOperatorPhase2Limit: new UntypedFormControl(this.entity.chargingStationDlm?.dlmOperatorPhase2Limit, this.formService.validators['DlmOperatorPhase2Limit']),
      DlmOperatorPhase3Limit: new UntypedFormControl(this.entity.chargingStationDlm?.dlmOperatorPhase3Limit, this.formService.validators['DlmOperatorPhase3Limit']),
      DlmInput1CurrOffsetCfg: new UntypedFormControl(this.entity.chargingStationDlm?.dlmInput1CurrOffsetCfg ? 1 : 0, this.formService.validators['DlmInput1CurrOffsetCfg']),
      DlmInput1Polarity: new UntypedFormControl(this.entity.chargingStationDlm?.dlmInput1Polarity ? 1 : 0, this.formService.validators['DlmInput1Polarity']),
      DlmInput1CurrOffsetPhase1: new UntypedFormControl(this.entity.chargingStationDlm?.dlmInput1CurrOffsetPhase1, this.formService.validators['DlmInput1CurrOffsetPhase1']),
      DlmInput1CurrOffsetPhase2: new UntypedFormControl(this.entity.chargingStationDlm?.dlmInput1CurrOffsetPhase2, this.formService.validators['DlmInput1CurrOffsetPhase2']),
      DlmInput1CurrOffsetPhase3: new UntypedFormControl(this.entity.chargingStationDlm?.dlmInput1CurrOffsetPhase3, this.formService.validators['DlmInput1CurrOffsetPhase3']),
      DlmExtMeterEnabled: new UntypedFormControl(this.entity.chargingStationDlm?.dlmExtMeterEnabled ? 1 : 0, this.formService.validators['DlmExtMeterEnabled']),
      SecondMeterType: new UntypedFormControl(this.entity.chargingStationDlm?.secondMeterType, this.formService.validators['SecondMeterType']),
      SecondMeterIPAddress: new UntypedFormControl(this.entity.chargingStationDlm?.secondMeterIPAddress, this.formService.validators['secondMeterIPAddress']),
      SecondMeterTCPPortNumber: new UntypedFormControl(this.entity.chargingStationDlm?.secondMeterTCPPortNumber, this.formService.validators['SecondMeterTCPPortNumber']),
      DlmExtMeterMainDistributionLimitPhase1: new UntypedFormControl(this.entity.chargingStationDlm?.dlmExtMeterMainDistributionLimitPhase1, this.formService.validators['DlmExtMeterMainDistributionLimitPhase1']),
      DlmExtMeterMainDistributionLimitPhase2: new UntypedFormControl(this.entity.chargingStationDlm?.dlmExtMeterMainDistributionLimitPhase2, this.formService.validators['DlmExtMeterMainDistributionLimitPhase2']),
      DlmExtMeterMainDistributionLimitPhase3: new UntypedFormControl(this.entity.chargingStationDlm?.dlmExtMeterMainDistributionLimitPhase3, this.formService.validators['DlmExtMeterMainDistributionLimitPhase3']),
      DlmExtLoadHeadroomPhase1: new UntypedFormControl(this.entity.chargingStationDlm?.dlmExtLoadHeadroomPhase1, this.formService.validators['DlmExtLoadHeadroomPhase1']),
      DlmExtLoadHeadroomPhase2: new UntypedFormControl(this.entity.chargingStationDlm?.dlmExtLoadHeadroomPhase2, this.formService.validators['DlmExtLoadHeadroomPhase1']),
      DlmExtLoadHeadroomPhase3: new UntypedFormControl(this.entity.chargingStationDlm?.dlmExtLoadHeadroomPhase3, this.formService.validators['DlmExtLoadHeadroomPhase1']),
      DlmExtMeterLoadFallbackPhase1: new UntypedFormControl(this.entity.chargingStationDlm?.dlmExtMeterLoadFallbackPhase1, this.formService.validators['DlmExtMeterLoadFallbackPhase1']),
      DlmExtMeterLoadFallbackPhase2: new UntypedFormControl(this.entity.chargingStationDlm?.dlmExtMeterLoadFallbackPhase2, this.formService.validators['DlmExtMeterLoadFallbackPhase2']),
      DlmExtMeterLoadFallbackPhase3: new UntypedFormControl(this.entity.chargingStationDlm?.dlmExtMeterLoadFallbackPhase3, this.formService.validators['DlmExtMeterLoadFallbackPhase3']),
      DlmExtMeterLocation: new UntypedFormControl(this.entity.chargingStationDlm?.dlmExtMeterLocation ? 1 : 0, this.formService.validators['DlmExtMeterLocation']), //(0) Inklusive Ladestations-Unterverteilung (1) Ohne Ladestations-Unterverteilung Def: Inklusive Ladestations-Unterverteilung
      DlmExtLoadAvgLen: new UntypedFormControl(this.entity.chargingStationDlm?.dlmExtLoadAvgLen, this.formService.validators['DlmExtLoadAvgLen']),
      DlmCurrImbalancePreventionEnabled: new UntypedFormControl(this.entity.chargingStationDlm?.dlmCurrImbalancePreventionEnabled ? 1 : 0, this.formService.validators['DlmExtMeterEnabled']),
      DlmCurrImbalanceLim: new UntypedFormControl(this.entity.chargingStationDlm?.dlmCurrImbalanceLim, this.formService.validators['DlmCurrImbalanceLim']),
      DlmMinCurrentRating: new UntypedFormControl(this.entity.chargingStationDlm?.dlmMinCurrentRating, this.formService.validators['DlmMinCurrentRating']),
      DlmDisconnectedLimit: new UntypedFormControl(this.entity.chargingStationDlm?.dlmDisconnectedLimit, this.formService.validators['DlmDisconnectedLimit']),
      dlmDiscoveryNetworkId: new UntypedFormControl(this.entity.chargingStationDlm?.dlmDiscoveryNetworkId, this.formService.validators['dlmDiscoveryNetworkId']),
      DlmMasterIp: new UntypedFormControl(this.entity.chargingStationDlm?.dlmMasterIp, this.formService.validators['DlmMasterIp']),
      DlmSlaveSolarEnabled: new UntypedFormControl(this.entity.chargingStationDlm?.dlmSlaveSolarEnabled ? 1 : 0, this.formService.validators['DlmSlaveSolarEnabled']),
      DlmSolarMode_dlm: new UntypedFormControl(this.entity.chargingStationDlm?.dlmSolarMode_dlm ? 1 : 0, this.formService.validators['DlmSolarMode_dlm']),
    });

    if (!this.isFirmwareSolarModeSuppoerted()) {
      this.formService.form.get('DlmSlaveSolarEnabled').disable();
      this.formService.form.get('DlmSolarMode_dlm').disable();
    }
  }
  public isNotDeactivated() {
    return this.formService.form.get('dlmMode') ? this.formService.form.get('dlmMode').value != 0 : false;

  }

  public isTypeMaster() {
    return this.formService.form.get('dlmMode') ? ((this.formService.form.get('dlmMode').value == 1) || (this.formService.form.get('dlmMode').value == 2)) : false;
  }

  public isNotStandAlone() {
    return this.formService.form.get('dlmMode') ? (this.formService.form.get('dlmMode').value != 2) : false;
  }

  public isMasterFixedIP() {
    return this.formService.form.get('dlmMode') ? this.formService.form.get('dlmMode').value == 4 : false;

  }

  public isSecondMeterEnable() {
    return this.formService.form.get('DlmExtMeterEnabled') ? this.formService.form.get('DlmExtMeterEnabled').value == 1 : false;
  }

  public isOptoActivated() {
    return this.formService.form.get('DlmInput1CurrOffsetCfg') ? this.formService.form.get('DlmInput1CurrOffsetCfg').value == 1 : false;
  }

  public isDlmCurrImbalancePreventionEnabled() {
    return this.formService.form.get('DlmCurrImbalancePreventionEnabled') ? this.formService.form.get('DlmCurrImbalancePreventionEnabled').value == 1 : false;
  }

  public isFirmwareSolarModeSuppoerted() {
    return compareVersions(this.entity.firmware, '5.31.0') > 0
  }

  onSubmit(formValue) {
    this.spinner.show()
    const patchDlmMode: PatchDlmMode = {
      chargingPower: formValue.chargingPower,
      dlmMode: formValue.dlmMode,
      dlmDiscoveryNetworkId: formValue.dlmDiscoveryNetworkId,
      dlmMasterIp: formValue.DlmMasterIp,
      dlmDisableDiscoveryBroadcast: (formValue.DlmDisableDiscoveryBroadcast == 1),
      dlmRecalcInterval: formValue.DlmRecalcInterval,
      dlmAllowEVWakeup: (formValue.DlmAllowEVWakeup == 1),
      dlmPhase1Limit: formValue.DlmPhase1Limit,
      dlmPhase2Limit: formValue.DlmPhase2Limit,
      dlmPhase3Limit: formValue.DlmPhase3Limit,
      dlmOperatorPhase1Limit: formValue.DlmOperatorPhase1Limit,
      dlmOperatorPhase2Limit: formValue.DlmOperatorPhase2Limit,
      dlmOperatorPhase3Limit: formValue.DlmOperatorPhase3Limit,
      dlmInput1CurrOffsetCfg: (formValue.DlmInput1CurrOffsetCfg == 1),
      dlmInput1Polarity: (formValue.DlmInput1Polarity == 1),
      dlmInput1CurrOffsetPhase1: formValue.DlmInput1CurrOffsetPhase1,
      dlmInput1CurrOffsetPhase2: formValue.DlmInput1CurrOffsetPhase2,
      dlmInput1CurrOffsetPhase3: formValue.DlmInput1CurrOffsetPhase3,
      dlmExtMeterEnabled: (formValue.DlmExtMeterEnabled == 1),
      secondMeterType: formValue.SecondMeterType,
      secondMeterIPAddress: formValue.SecondMeterIPAddress,
      secondMeterTCPPortNumber: formValue.SecondMeterTCPPortNumber,
      dlmExtMeterMainDistributionLimitPhase1: formValue.DlmExtMeterMainDistributionLimitPhase1,
      dlmExtMeterMainDistributionLimitPhase2: formValue.DlmExtMeterMainDistributionLimitPhase2,
      dlmExtMeterMainDistributionLimitPhase3: formValue.DlmExtMeterMainDistributionLimitPhase3,
      dlmExtLoadHeadroomPhase1: formValue.DlmExtLoadHeadroomPhase1,
      dlmExtLoadHeadroomPhase2: formValue.DlmExtLoadHeadroomPhase2,
      dlmExtLoadHeadroomPhase3: formValue.DlmExtLoadHeadroomPhase3,
      dlmExtMeterLoadFallbackPhase1: formValue.DlmExtMeterLoadFallbackPhase1,
      dlmExtMeterLoadFallbackPhase2: formValue.DlmExtMeterLoadFallbackPhase2,
      dlmExtMeterLoadFallbackPhase3: formValue.DlmExtMeterLoadFallbackPhase3,
      dlmExtMeterLocation: (formValue.DlmExtMeterLocation == 1),
      dlmExtLoadAvgLen: formValue.DlmExtLoadAvgLen,
      dlmCurrImbalancePreventionEnabled: (formValue.DlmCurrImbalancePreventionEnabled == 1),
      dlmCurrImbalanceLim: formValue.DlmCurrImbalanceLim,
      dlmMinCurrentRating: formValue.DlmMinCurrentRating,
      dlmDisconnectedLimit: formValue.DlmDisconnectedLimit,
      dlmClearPersistentSlaves: this.dlmClearPersistentSlaves,
      dlmSlaveSolarEnabled: (formValue.DlmSlaveSolarEnabled == 1),
      dlmSolarMode_dlm: (formValue.DlmSolarMode_dlm == 1)
    }
    this.chargingStationsService.configureDlmMode(this.entity.id, patchDlmMode).subscribe(result => {
      this.toastService.success('Änderungen im Lastmanagement erfolgreich gespeichert.');
      this.entityLoadedEvent.emit(this.entity);
      this.spinner.hide()
      if (this.isRestartNecessary) {
        this.chargingStationsService.resetChargingstation(this.entity.id).subscribe(result => {
          this.toastService.success('Ladestation wird neugestartet...');
          this.entityLoadedEvent.emit(this.entity);
          this.spinner.hide()
        }, error => {
          this.toastService.error('Ladestation könnte derzeit nicht neustarten');
          console.error(error);
          this.spinner.hide()
        });
      }
    }, error => {
      this.toastService.error('Änderungen konnten nicht gespeichert werden.');
      console.error(error);
      this.entityLoadedEvent.emit(this.entity);
      this.spinner.hide()
    });
  }

  showConfirmRestartDialog(formValue) {
    Swal.fire({
      title: 'Ladestation Neustarten?',
      text: 'Wollen Sie die DLM Einstellungen speichern und die Ladestation neustarten?',
      icon: 'question',
      confirmButtonText: 'Bestätigen',
      confirmButtonColor: '#212529',
      showCancelButton: true,
      cancelButtonText: 'Abbrechen',
      cancelButtonColor: '#212529'
    }).then((result) => {
      if (result.isConfirmed) {
        this.onSubmit(formValue);
      }
    })
  }

  afterInit() {
    this.DlmModeMapping();
  }

  DlmModeMapping() {
    switch (this.entity.chargingStationDlm?.dlmMode) {
      case DlmMode.Deaktiviert:
        this.entity.dlmMapping = 'Deaktiviert';
        break;
      case DlmMode.DLMMasterWithInternalSlave:
        this.entity.dlmMapping = 'DLM - Master(mit internem DLM - Slave)';
        break;
      case DlmMode.Standalone:
        this.entity.dlmMapping = 'DLM-Master (Standalone)';
        break;
      case DlmMode.MasterAutoDiscovery:
        this.entity.dlmMapping = 'DLM-Slave (Master-Auto-Discovery)';
        break;
      case DlmMode.MasterFixedIP:
        this.entity.dlmMapping = 'DLM-Slave (Master-Fixed-IP)';
        break;
      default:
        this.entity.dlmMapping = 'Test';
        break;
    }
  }

  changeOperatorPower(power: number) {
    var result = this.chargingStationsService.configureOperatorPower(this.entity.id, this.formService.form.get('operatorPower').value);
  }

  openRemoteStartStopDialog(start: boolean) {
    const dialogRef = this.dialog.open(RemoteStartStopDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.start = start;
    dialogRef.componentInstance.chargingStation = this.entity;

    dialogRef.result.then((result) => {
      if (result.success == true) {
        this.formService.form.get('isFreeCharge').disable();
      }
    }, (backdrop) => {
    });
  }

  openSuccessDialog() {
    Swal.fire({
      title: $localize`:@@ChangeDialogSaveSuccessHeader:Einstellungen wurden gespeichert!`,
      icon: 'success',
      confirmButtonText: $localize`:@@DialogOkButton:OK`,
      confirmButtonColor: 'green'
    }).then((result) => {
      this.createForm();
    });
  }

  needRestart() {
    this.isRestartNecessary = true;
  }

  confirmDlmClearPersistentSlaves() {
    this.dlmClearPersistentSlaves = true;
  }
}
